import { AgentType } from "./types";

export const AVAILABLE_AGENT_TYPES = [
  {
    type: AgentType.APPLICATION_SUPPORT_AGENT,
    label: "Application support agent",
    description:
      "Review and resolve applicant escalation signals to drive submitted applications. All agent actions are reviewed and approved by a human.",
    singleInstance: true,
    features: [
      "Answer questions or detects blockers about an application",
      "Steps in to resolve issues and informs the property manager when done",
      "Answers questions about an application"
    ]
  },
  {
    type: AgentType.LEASING_AGENT,
    label: "Leasing agent",
    description:
      "Qualify prospective tenants, answer questions about inventory and policies, create leads, and schedule showings.",
    singleInstance: true,
    features: [
      "Answer caller questions about inventory, showing availability, policies, etc. ",
      "Receive and/or re-route inbound calls",
      "Automatically draft responses to inbound texts & emails"
    ]
  }
];

/**
 * Display name per agent type. Kept separate from AVAILABLE_AGENT_TYPES because
 * not every type is addable: the collection agent is granted by a feature flag,
 * so it needs a label in the table without appearing in the add-agent wizard.
 */
export const AGENT_TYPE_LABELS: Record<AgentType, string> = {
  [AgentType.APPLICATION_SUPPORT_AGENT]: "Application support agent",
  [AgentType.LEASING_AGENT]: "Leasing agent",
  [AgentType.COLLECTION_AGENT]: "Collection agent"
};

export const COLLECTION_AGENT_DESCRIPTION =
  "Contact tenants with a past due balance by email, text and voice to bring overdue balances down. Hardship and exception requests are always handed to a person.";

export const agentsPath = "portal/v1/agents";

export const AGENTS_QUERY_KEY = ["AGENTS"];

export const agentQueryKey = (agentId: number | string) => [
  "AGENTS",
  String(agentId)
];
